import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    isLoading: false,
    updated: null,
    violations: {},
    retrieved: {
      packageItems: [],
      packagePromotions: [],
      packageDevices: []
    }
  },
  getters: {
    isLoading: (state) => state.isLoading,
    updated: (state) => state.updated,
    violations: (state) => state.violations,
    retrieved: (state) => state.retrieved
  },
  mutations: {
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setUpdated (state, updated) {
      state.updated = updated
    },
    reset (state) {
      state.updated = null
      state.isLoading = false
      state.violations = {}
      state.package = {}
    },
    setViolations (state, violations) {
      state.violations = violations
    },
    setRetrieved (state, payload) {
      Object.assign(state.retrieved, payload)
      // modifying data to fit form
      state.retrieved.packageItems = state.retrieved.packageItems.map(entry => {
        return {
          '@id': entry['@id'],
          item: entry.item,
          priceBrutto: entry.priceBrutto,
          priceNetto: entry.priceNetto,
          purchasePriceNetto: entry.purchasePriceNetto,
          vatValue: Math.round((entry.priceBrutto - entry.priceNetto) * 100) / 100
        }
      })
      state.retrieved.packagePromotions = state.retrieved.packagePromotions.map(entry => {
        return { '@id': entry['@id'], promotion: entry.promotion }
      })
      state.retrieved.packageDevices = state.retrieved.packageDevices.map(entry => {
        return { '@id': entry['@id'], device: entry.device }
      })
    }
  },
  actions: {
    async retrieve ({ commit }, id) {
      commit('toggleLoading')
      const response = await new ApiService(`${id}`).getResults()
      commit('setRetrieved', response)
      commit('toggleLoading')
    },
    async update ({ commit }, data) {
      // modyfing data to fit expected server-side pattern
      data.packageItems = data.packageItems.map(entry => {
        return {
          '@id': entry['@id'],
          item: entry.item,
          priceBrutto: entry.priceBrutto.toString(),
          priceNetto: entry.priceNetto.toString(),
          purchasePriceNetto: entry.purchasePriceNetto.toString(),
          vatValue: Math.round((entry.priceBrutto - entry.priceNetto) * 100) / 100,
          package: data['@id']
        }
      })
      data.packagePromotions = data.packagePromotions.map(entry => {
        return { '@id': entry['@id'], promotion: entry.promotion, package: data['@id'] }
      })
      data.packageDevices = data.packageDevices.map(entry => {
        return { '@id': entry['@id'], device: entry.device, package: data['@id'] }
      })
      const response = await new ApiService(data['@id']).put(data)
      if (response.status < 300) commit('setUpdated', await response.json())
      else commit('setViolations', response)
    },
    reset ({ commit }) {
      commit('reset')
    }
  }
}
